import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import { items, Product } from '../../interfaces/user';

interface Props {
  items: items[];
  products: Product[];
  onClose: () => void;
}

const OrderItemsModal: React.FC<Props> = ({ items, products, onClose }) => {
  const getProductName = (productId: string) => {
    const product = products.find(p => p.id === productId);
    return product ? product.name : 'Unknown Product';
  };

  const columns: TableColumn<items>[] = [
    { name: 'Product Name', selector: row => getProductName(row.productId), center: true },
    { name: 'Quantity', selector: row => row.quantity, center: true },
    { name: 'Price', selector: row => `₹${parseFloat(row.price).toFixed(2)}`, center: true },
    { name: 'Total', cell: row => `₹${(parseFloat(row.price) * parseInt(row.quantity)).toFixed(2)}`, center: true },
  ];

  return (
    <div className="card fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-2xl w-[40rem] max-w-[90vw]">
        <h2 className="text-xl font-semibold text-center text-blue-600 mb-4">Order Items</h2>

        <DataTable
          columns={columns}
          data={items}
          striped
          highlightOnHover
          pagination
          paginationPerPage={5}
        />

        <div className="text-center mt-6">
          <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default OrderItemsModal;
